export const CHAT = 'دردشة';
export const INFO = 'معلومات';
export const MATERIAL = 'المنهج';
export const RESOURCES = 'مصادر';
export const TASKS = 'مهام';
export const TYPE_A_MESSAGE = 'اكتب رسالة ...';
export const LOGOUT_ALL_DEVICES = 'تسجيل الخروج من جميع الأجهزة';
export const LAST_ACTIVE = 'اخر نشاط';
export const NEW_ACCOUNT = 'اضافة حساب';
export const ACCOUNTS = 'الحسابات';
export const COPY = 'نسخ';
export const PIN = 'تثبيت';
export const FORWARD = 'تحويل';
export const REPLY = 'رد';
export const SEND_TO = 'أرسل إلى';
export const MESSAGE = 'إرسال رسالة';
export const DELETE_MSG = 'مسح هذه الرسالة؟';
export const DELETE_FOR_ME = 'مسح الرسالة لي';
export const DELETE_FOR_EVERYONE = 'مسح الرسالة للجميع';
export const CHANGE_NAME = 'تغيير الاسم';
export const UPDATE_STATUS = 'تغيير الحالة';
export const CHANGE_AVATAR = 'تغيير الصورة';
export const ONLINE = 'متصل';
export const LAST_ACTIVITY = 'اخر نشاط: ';
export const CITY_SESSION = session => `بدأ في ${session.city} - ${session.country}`;
export const SESSION_DELETE_MSG = 'هل أنت متأكد من ازالة هذا الجهاز';
export const ACCOUNT_REMOVE_MSG = 'هل أنت متأكد من ازالة هذا الحساب';
export const UNREAD_MESSAGES = 'رسائل غير مقروءة';



// WEBPACK FOOTER //
// ./src/lang/ar/middle.js